'use strict';

import template from './template.html';


export default function() {
	'ngInject';

	return {
		scope: true,
		template: template,
		require: '^userListContainer',
	};

}
